import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationService } from '@zaoblako/web/core/services/notification/notification.service';
import { WebsocketNotificationService } from '@zaoblako/web/core/services/notification/websocket-notification.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { BadgeModule } from 'primeng/badge';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'crm-lk-eu-notification-icon',
  standalone: true,
  imports: [CommonModule, BadgeModule],
  templateUrl: './lk-eu-notification-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LkEuNotificationIconComponent implements OnInit {
  public unreadCount$: Observable<number>;

  @Input() public isShow = false;
  @Output() public isShowChange = new EventEmitter<boolean>();

  public constructor(
    private readonly authService: AuthService,
    private readonly websocketNotificationService: WebsocketNotificationService,
    private readonly notificationService: NotificationService
  ) {}

  public ngOnInit(): void {
    this.websocketNotificationService.createWSConnection(
      this.authService.getToken,
      this.authService?.currentUser?.id,
      true
    );

    this.unreadCount$ = this.notificationService.unreadCount$.pipe(
      map((unreadCount) => {
        return unreadCount.HELPDESK + unreadCount.PERSONAL;
      })
    );
  }

  public showChangeValue() {
    this.isShow = true;
    this.isShowChange.emit(this.isShow);
  }
}
